<!--
  - Author: Raul Perusquia <raul@inikoo.com>
  - Created: Tue, 04 Apr 2023 08:47:34 Malaysia Time, Sanur, Bali, Indonesia
  - Copyright (c) 2023, Raul A Perusquia Flores
  -->

<script setup lang="ts">
import { provide } from "vue"
import { useLayoutStore } from "@/Stores/layout"

import { usePage } from '@inertiajs/vue3'
// import { loadLanguageAsync } from 'laravel-vue-i18n'
// import { breakpointType } from '@/Composables/useWindowSize'
import ScreenWarning from "@/Components/Utils/ScreenWarning.vue"
import Notification from '@/Components/Utils/Notification.vue'

provide('layout', useLayoutStore())

// if (usePage().props.language) {
//     loadLanguageAsync(usePage().props.language)
// }

const layout = useLayoutStore()


console.log('environment:', useLayoutStore().app.environment)


</script>

<template>
    <ScreenWarning v-if="layout.app.environment === 'staging'" />
    <div class="h-screen w-screen bg-gradient-to-bl from-sky-100 via-sky-50 to-sky-200 flex flex-col gap-y-8 items-center justify-center">
        <div class="mx-auto w-full max-w-xl -mt-20">
            <div class="relative bg-white/65 py-8 px-4 shadow rounded-lg md:px-10">
                <img src="logo_300.png" alt="" class="mb-8 mx-auto h-16 rounded-2xl">

                <slot />
            </div>
        </div>
    </div>

    <!-- Global declaration: Notification -->
    <notifications
        dangerously-set-inner-html
        :max="3"
        width="500"
        classes="custom-style-notification"
        :pauseOnHover="true"
    >
        <template #body="props">
            <Notification :notification="props" />
        </template>
    </notifications>
</template>
